import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({}), { index: 1 });
export default useStyles;
